import React, { useEffect, useState } from 'react'
import {
	IdleTimerProvider,
	useIdleTimerContext,
	workerTimers,
} from 'react-idle-timer'
import { Analytics, history, UserHelper } from '@Techedge/digitalportal-shared'

export default (props: any) => {
	// const TAG: string =
	// 	'------------------------------------REACT-IDLE-TIMER-PROVIDER------------------------------------'
	// const STATUS = { IDLE: 'IDLE', ACTIVE: 'ACTIVE' }
	const { children, providerName, disableLogout, userProfile } = props
	// const timeout: number = 180000000
	const [timeout, setTimeout] = useState<number>(86400000)
	// const logoutTime: number = 120000
	const idleTimer = useIdleTimerContext()
	const [isIdle, setIsIdle] = useState(false)

	useEffect(() => {
		const idleTimeoutMap = JSON.parse(process.env.IDLE_TIMEOUT_MAP)
		setTimeout(idleTimeoutMap[userProfile] || idleTimeoutMap.default)
	}, [])

	useEffect(() => {
		// let timeoutLogout = setTimeout(() => {
		// 	console.log('logout', isIdle)
		// 	if (isIdle && !disableLogout) {
		// 		UserHelper._shared().doLogout()
		// 	}
		// }, logoutTime)

		// return () => {
		// 	clearTimeout(timeoutLogout)
		// }
		if (isIdle && !disableLogout) {
			UserHelper._shared().doLogout()
			history.push(process.env.DP + '/logout')
		}
	}, [isIdle])

	const onPrompt = () => {
		// Fire a Modal Prompt
	}

	const onIdle = () => {
		// Close Modal Prompt
		// Do some idle action like log out your user
		Analytics._sendAnalyticsLinkEvent('Account', 'Inactivity', 'Static')
		setIsIdle(true)
		if (idleTimer) {
		}
	}

	const onActive = (event) => {
		// Close Modal Prompt
		// Do some active action
		setIsIdle(false)
	}

	const onAction = (event) => {
		// Do something when a user triggers a watched event
	}

	return (
		<IdleTimerProvider
			timeout={timeout}
			onPrompt={onPrompt}
			onIdle={onIdle}
			onActive={onActive}
			onAction={onAction}
			onMessage={() => {}}
			syncTimers={300}
			name={providerName}
			timers={workerTimers}
			crossTab>
			{children}
		</IdleTimerProvider>
	)
}
